// extracted by mini-css-extract-plugin
export default {"container":"SharedLayout_container__SSFEK","content":"SharedLayout_content__pm5I2","footer":"SharedLayout_footer__sAI-v"};